import { render, staticRenderFns } from "./batchTasks.vue?vue&type=template&id=27a58f27&"
import script from "./batchTasks.vue?vue&type=script&lang=js&"
export * from "./batchTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports